import React, { Component } from 'react'
import Homebuttons from './Homebuttons'
import { topickeys, topicnames,getStats } from './AnswerFormats'


export default class Stats extends Component {

    state = {

    }

    constructor(props){
        super(props);
        this.state.stats = getStats();
    }

    deleteStats = () => {
        localStorage.removeItem('stats');
        this.setState({stats: getStats()});
    }

    render() {

        const statBars = topickeys.map((name,index) => {
            let stats=this.state.stats[name];
            let percent = (stats[0]+stats[1]===0) ? 0 : stats[0]/(stats[0]+stats[1])*100;
            //let width=(percent===0) ? "10px" : percent+"%";
            let width = percent + "%";
            let statNumbers=stats[0]+"/"+(stats[0]+stats[1])+"\t"+percent.toFixed(2)+"%";
            return (
            <div key = {name} className = "statBlock">
                <div className = "statHeader">
                <div>{topicnames[index]}</div>
                <div>{statNumbers}</div>
                </div>
                <div className = "statBar">
                    <div style = {{width: width, height: "2em"}} className = "correctBar"></div>
                </div>
            </div>);
        });

        return (
            <div className = "home">
                <div className = "header home">
                    User Statistics
                </div>

                <div className='container'>
                    <div className = "lightblue">
                        <Homebuttons />
                    </div>

                    <div className = "stats">
                    <button onClick = {this.deleteStats}>Reset</button>
                        {statBars}
                    </div>

                </div>
            </div>
        )
    }
}
